import clsx from 'clsx'
import React from 'react'

import { Icon } from '../'

import './Loader.scss'

const Loader = ({ className, isDarkTheme }) => {
   return (
      <div className={clsx('Loader', className, isDarkTheme && 'Loader--dark')}>
         <Icon className="Loader__icon" name="spinner" />
      </div>
   )
}

export default Loader
